
import AuthManager from '~/fc/Auth/AuthManager'
import { updateFreshDeskPageData, hideWidget, showWidget } from "~/fc/FreshDesk";
import FreshdeskWidgetLoader from '~/components/ui/FreshdeskWidgetLoader'
import { handleTelemetryExpiry } from "~/fc/TelemetryEvents";

export default {
    name: 'BlankLayout',
    middleware: "redirection",
    components: {
        FreshdeskWidgetLoader,
        Navigation: () => import(/* webpackChunkName: "Navigation" */ './partials/navigation/Navigation'),
        ToastContainer: () => import(/* webpackChunkName: "ToastContainer" */ '../components/ui/ToastContainer'),
        BirdEatsBugTrigger: () => import(/* webpackChunkName: "BirdEatsBugTrigger" */ '~/components/ui/BirdEatsBugTrigger'),
    },
    computed: {
        authManager() { return new AuthManager(this) },
        dialogIsOpen () { return this.$store.state.store.dialogIsOpen },
    },
    watch: {
        $route(to, from) {
            if(process.client) {
                updateFreshDeskPageData(this)
                this.authManager.checkExpiryOfToken()
            }
        },
        dialogIsOpen(val) {
            if (val) hideWidget()
            else showWidget()
        }
    },
    mounted() {
        if(process.client) {
            handleTelemetryExpiry()
            this.authManager.checkExpiryOfToken()
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    if (window.innerWidth <= 768) { this.$store.commit('store/updateIsMobile', true) } 
                    else { this.$store.commit('store/updateIsMobile', false) }
                })
            })
        }
    }
}
